import { Injectable } from '@angular/core';
import { Router, type UrlTree } from '@angular/router';
import { environment } from '../../../environments/environment';


@Injectable({
    providedIn: 'root'
})
export class ShowSensoresGuardService {

    constructor(public router: Router) {
        void router;
    }

    canActivate(): boolean | UrlTree {

        if (!environment.features.showSensores) {
            return this.router.parseUrl('/login');
        }

        return true;
    }
}
